import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { PagesManager } from './pages/PagesManager';
import { ScheduleBuilder } from './pages/ScheduleBuilder';
import { InfoscreenManager } from './pages/InfoscreenManager';
import { UsersManager } from './pages/UsersManager';
import { SettingsManager } from './pages/SettingsManager';
import { SsoCallback } from './pages/SsoCallback';
import './App.css';
import './theme.css';

const Navigation: React.FC = () => {
  const auth = React.useContext(AuthContext);

  if (!auth.isAuthenticated) return null;

  const isAdmin = auth.user?.role === 'admin';

  return (
    <nav className="main-nav">
      <div className="nav-brand">Display CMS</div>
      <div className="nav-links">
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>Dashboard</NavLink>
        <NavLink to="/pages" className={({ isActive }) => isActive ? 'active' : ''}>Seiten</NavLink>
        <NavLink to="/schedules" className={({ isActive }) => isActive ? 'active' : ''}>Schedules</NavLink>
        <NavLink to="/infoscreens" className={({ isActive }) => isActive ? 'active' : ''}>Infoscreens</NavLink>
        {isAdmin && <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>Benutzer</NavLink>}
        {isAdmin && <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>Einstellungen</NavLink>}
      </div>
      {auth.user && (
        <div className="nav-user">
          <span>{auth.user.name}</span>
          <span className="nav-role-badge">{auth.user.role}</span>
        </div>
      )}
      <button className="nav-logout" onClick={auth.logout}>Abmelden</button>
    </nav>
  );
};

const AppContent: React.FC = () => {
  const auth = React.useContext(AuthContext);

  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sso" element={<SsoCallback />} />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsManager />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pages"
          element={
            <ProtectedRoute>
              <PagesManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/schedules"
          element={
            <ProtectedRoute>
              <ScheduleBuilder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/infoscreens"
          element={
            <ProtectedRoute>
              <InfoscreenManager />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/"
          element={
            auth.isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
          }
        />
      </Routes>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
